import { combineReducers } from '@reduxjs/toolkit';
import config from './config';
import chooseorg from './chooseorg';

export default combineReducers({
  config,
  chooseorg,
});
